import {
    AnyError,
    isAavoBackendError,
    isAavoErrorResponse,
} from "src/errorHandling/anyError";
import {isError} from "src/errorHandling/errorUtils";

export const logError = (error: AnyError) => {
    let message: any = undefined;
    if (isAavoErrorResponse(error)) {
        logError(error.response.data);
    } else if (isAavoBackendError(error)) {
        if (error.logAsError === false) return;

        message = error;
    } else if (isError(error)) {
        message = error.message;
    } else {
        message = error;
    }

    if (message !== undefined) console.error(JSON.stringify(message));
};
